import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_METHOD } from "./apiRoutes";

interface getProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getPaymentMethodIncludeDelete = async (communityId: string) => await axiosAuth.get(`${PAYMENT_METHOD}/community/${communityId}/including-deleted`);

const useGetPaymentMethodIncludeDelete = ({
  communityId,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-method"],
    queryFn: () => getPaymentMethodIncludeDelete(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentMethodIncludeDelete;
